'use strict'

import React from 'react';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx'
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';

import {Risk} from '../Risk.jsx';

import formDefinition from './riskManagamentApproachFormDefinition.js';
import Translations from '../../app/utils/translations.js';

import sendCommand from '../../app/utils/sendCommand.js';

let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

export class RiskManagementApproach extends React.Component {
  constructor(props) {
    super(props);
    var selected=0;
    if (typeof window!=="undefined" && window.location.hash.length>0) {
      formDefinition.forEach((area,index) =>{
        if (area.name===window.location.hash.slice(1)) {
          selected=index;
        }
      })
    }
    this.state={
      approach:Object.assign({},this.props.project.riskApproach, {
        id: this.props.project.riskApproach!==undefined ? "savedApproach" : undefined,
        _progress:"riskManagementApproach"
      }),
      fullWidth: props.details==="presentation",
      selected: selected,
      items: props.risks
    };
  }

  updateRiskItems(items) {
    this.setState({items:items, modified: true});
  }

  summary(area, details) {
    let labels=translations.getTranslation(this.props);
    switch (area) {
      case "riskRegister":
        return (
          <Risk
            {...this.props}
            risks={this.state.items}
            onUpdate={this.updateRiskItems.bind(this)}
            onDetails={details.onDetails}
            onPresentation={()=>this.setState({fullWidth:true})}
          />
        );
      default:
        return (
          <i>{labels[area].description}</i>
        );
    }
  }

  updateApproach(approach) {
    let updatedApproach=Object.assign({},approach,{_progress:undefined});
    var command={type:"updateRiskManagementApproach", approach:updatedApproach};
    if (this.props.project.isProduct) {
      command=Object.assign({},command,{
        product: {id: this.props.project.id}
      });
    } else if (this.props.project.isRelease) {
      command=Object.assign({},command,{
        release: {id: this.props.project.id}
      });
    } else if (this.props.project.isProgramme) {
      command=Object.assign({},command,{
        programme: {id: this.props.project.id}
      });
    } else {
      command=Object.assign({},command,{
        project:{id:this.props.project.id}
      });
    }
    sendCommand(command)
      .then(response=>{
        this.setState({
          approach: Object.assign({},this.state.approach, response.approach, {id:"saved"}),
          modified: undefined
        });
      })
      .catch(error=>{
        console.log("Got error: "+JSON.stringify(error),error);
        alert("Error saving approach.");
      });
  }

  redirectToHomePage(event) {
    var type=this.props.project.isProduct
      ? "/products"
      : this.props.project.isProgramme
        ? "/programmes"
        : "/projects";
    window.location=type+"/"+this.props.project.id;
  }

  render() {
    let labels=translations.getTranslation(this.props);
    return this.state.fullWidth ? (
      <Risk
        {...this.props}
        risks={this.state.items}
        onUpdate={this.updateRiskItems.bind(this)}
        view="present"
        onListView={()=>this.setState({fullWidth:undefined})}
      />
    ) : (
      <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          <AreaForm
            {...this.props}
            items={this.state.items}
            areas={translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)}
            display="tab"
            label={labels.general.approach}
            item={this.state.approach}
            selected={this.state.selected}
            summary={this.summary.bind(this)}
            onUpdate={this.updateApproach.bind(this)}
            modified={this.state.modified}
            onCancel={this.redirectToHomePage.bind(this)}
          />
        </div>
      </div>
    )
  }
}

export default class RiskPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return this.props.fullPage ? (
      <RiskManagementApproach {...this.props}/>
    ) : (
      <Layout {...this.props} projectMenu={menu}>
        <RiskManagementApproach {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/risk/Approach.jsx